.pageLayout {
  height: 100vh;
}

.pageContent {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  overflow: auto;
}
